import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'red-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
